import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { ControlledDatePicker, ControlledTextField } from 'components/shared';
import { ControlledFlagCheckbox } from 'components/shared/ControlledFields/ControlledFlagCheckbox';

import MethodSelectSection from './MethodSelectSection';
import NumericFieldSection from './NumericFieldsSection';
import ServiceBrSection from './ServiceBrSection';
import VatSelectSection from './VatSelectSection';
import Grid from '@mui/material/Grid';

export default function DetailsForm() {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <>
      <ControlledTextField
        name="description"
        type="string"
        control={control}
        variant="outlined"
        label={t('surchargesMaintenance.form.description')}
      />
      <MethodSelectSection />
      <ControlledFlagCheckbox
        flag="REQUEST_BASED_SERVICE_FLAG"
        name={`flags`}
        label={t('surchargesMaintenance.form.flags.REQUEST_BASED_SERVICE_FLAG')}
      />
      <ServiceBrSection />
      <Box gap={2.5} maxWidth={440} paddingTop={2}>
        <NumericFieldSection
          duty={'surcharge1Duty'}
          nominal={'surcharge1Nom'}
          percent={'surcharge1Perc'}
        />
        <NumericFieldSection
          duty={'surcharge3Duty'}
          nominal={'surcharge3Nom'}
          percent={'surcharge3Perc'}
        />
      </Box>
      <Box display="flex" gap={2.5} paddingBottom={2}>
        <Grid container spacing={2.5}>
          <Grid item xs={6}>
            <ControlledDatePicker
              control={control}
              name="valid.from"
              variant="outlined"
              label={t('validFrom')}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <ControlledDatePicker
              control={control}
              name="valid.to"
              variant="outlined"
              label={t('validTo')}
              fullWidth
            />
          </Grid>
        </Grid>
      </Box>
      <VatSelectSection control={control} />
    </>
  );
}
